<template>
	<div>

		<v-form ref="unitary_form">

			<v-container grid-list-xs fluid class="pa-0">

				<div v-if="form.parameters.hasOwnProperty(parameters_names.job_title)">
					<div class="mb-1 background--text text--lighten-5 subheading">
						{{ parameters[parameters_names.job_title] | maestroParamLabel }}
					</div>
					<v-text-field
						solo
						:name="parameters_names.job_title"
						:rules="getValidationRules(parameters_names.job_title)"
						v-model="form.parameters[parameters_names.job_title]"
						class="grv-input">
					</v-text-field>
				</div>

				<div v-if="form.parameters.hasOwnProperty(parameters_names.output_folder)">
					<div class="mb-1 background--text text--lighten-5 subheading">
						{{ parameters[parameters_names.output_folder] | maestroParamLabel }}
					</div>
					<v-text-field
						solo
						:ref="parameters_names.output_folder"
						:name="parameters_names.output_folder"
						:rules="getValidationRules(parameters_names.output_folder)"
						@change="outputFolderPathCleaner(parameters_names.output_folder)"
						v-model="form.parameters[parameters_names.output_folder]"
						:prefix="getFileBasename(form.parameters[parameters_names.output_folder])"
						class="file-input grv-input"
						:append-icon="'folder_open'"
						@click:append="showFileExplorer(parameters[parameters_names.output_folder], null)">
					</v-text-field>
				</div>

				<v-layout row wrap align-start>
					<v-flex v-if="form.parameters.hasOwnProperty(parameters_names.audio_config)" shrink>
						<div class="mb-1 background--text text--lighten-5 subheading">
							{{ parameters[parameters_names.audio_config] | maestroParamLabel }}
						</div>
						<v-select
							solo
							dense
							:name="parameters_names.audio_config"
							:menu-props="{contentClass: 'grv-menu'}"
							class="grv-input pr-2"
							:rules="getValidationRules(parameters_names.audio_config)"
							@change="onAudioConfChange($event)"
							:items="parameters[parameters_names.audio_config].choices"
							v-model="form.parameters[parameters_names.audio_config]">
						</v-select>
					</v-flex>
					<v-flex v-if="form.parameters.hasOwnProperty(parameters_names.measurement_algorithm)" shrink>
						<div class="mb-1 background--text text--lighten-5 subheading">
							{{ parameters[parameters_names.measurement_algorithm] | maestroParamLabel }}
						</div>
						<v-select
							solo
							dense
							:name="parameters_names.measurement_algorithm"
							:menu-props="{contentClass: 'grv-menu'}"
							class="grv-input pr-2"
							:rules="getValidationRules(parameters_names.measurement_algorithm)"
							:items="parameters[parameters_names.measurement_algorithm].choices"
							v-model="form.parameters[parameters_names.measurement_algorithm]">
						</v-select>
					</v-flex>
					<v-flex v-if="form.parameters.hasOwnProperty(parameters_names.downmix_output_config)" shrink>
						<div class="mb-1 background--text text--lighten-5 subheading">
							{{ parameters[parameters_names.downmix_output_config] | maestroParamLabel }}
						</div>
						<v-select
							solo
							dense
							:name="parameters_names.downmix_output_config"
							:menu-props="{contentClass: 'grv-menu'}"
							class="grv-input pr-2"
							:rules="getValidationRules(parameters_names.downmix_output_config)"
							:items="parameters[parameters_names.downmix_output_config].choices"
							v-model="form.parameters[parameters_names.downmix_output_config]">
						</v-select>
					</v-flex>
					<v-flex v-if="form.parameters.hasOwnProperty(parameters_names.upmix_output_config)" shrink>
						<div class="mb-1 background--text text--lighten-5 subheading">
							{{ parameters[parameters_names.upmix_output_config] | maestroParamLabel }}
						</div>
						<v-select
							solo
							dense
							:name="parameters_names.upmix_output_config"
							:menu-props="{contentClass: 'grv-menu'}"
							class="grv-input pr-2"
							:rules="getValidationRules(parameters_names.upmix_output_config)"
							:items="parameters[parameters_names.upmix_output_config].choices"
							v-model="form.parameters[parameters_names.upmix_output_config]">
						</v-select>
					</v-flex>
					<v-flex v-if="form.parameters.hasOwnProperty(parameters_names.varispeed_config)" shrink>
						<div class="mb-1 background--text text--lighten-5 subheading">
							{{ parameters[parameters_names.varispeed_config] | maestroParamLabel }}
						</div>
						<v-select
							solo
							dense
							:name="parameters_names.varispeed_config"
							:menu-props="{contentClass: 'grv-menu'}"
							class="grv-input pr-2"
							:rules="getValidationRules(parameters_names.varispeed_config)"
							:items="parameters[parameters_names.varispeed_config].choices"
							v-model="form.parameters[parameters_names.varispeed_config]">
						</v-select>
					</v-flex>
					<v-flex v-if="form.parameters.hasOwnProperty(parameters_names.qt_profile)" shrink>
						<div class="mb-1 background--text text--lighten-5 subheading">
							{{ parameters[parameters_names.qt_profile] | maestroParamLabel }}
						</div>
						<v-select
							solo
							dense
							:name="parameters_names.qt_profile"
							:menu-props="{contentClass: 'grv-menu'}"
							class="grv-input pr-2"
							:rules="getValidationRules(parameters_names.qt_profile)"
							:items="parameters[parameters_names.qt_profile].choices"
							v-model="form.parameters[parameters_names.qt_profile]">
						</v-select>
					</v-flex>
					<v-flex v-if="form.parameters.hasOwnProperty(parameters_names.fps)" shrink>
						<div class="mb-1 background--text text--lighten-5 subheading">
							{{ parameters[parameters_names.fps] | maestroParamLabel }}
						</div>
						<v-select
							solo
							dense
							:name="parameters_names.fps"
							:menu-props="{contentClass: 'grv-menu'}"
							class="grv-input pr-2"
							:rules="getValidationRules(parameters_names.fps)"
							:items="parameters[parameters_names.fps].choices"
							v-model="form.parameters[parameters_names.fps]">
						</v-select>
					</v-flex>
					<v-flex v-if="form.parameters.hasOwnProperty(parameters_names.measurement_only)" shrink>
						<v-checkbox
							hide-details
							:name="parameters_names.measurement_only"
							:label="parameters[parameters_names.measurement_only] | maestroParamLabel"
							color="primary"
							style="padding-top: 32px !important;"
							class="mb-0 pr-2 grv-input"
							v-model="form.parameters[parameters_names.measurement_only]">
						</v-checkbox>
					</v-flex>
					<v-flex v-if="form.parameters.hasOwnProperty(parameters_names.harmonize)" shrink>
						<v-checkbox
							hide-details
							:name="parameters_names.harmonize"
							:label="parameters[parameters_names.harmonize] | maestroParamLabel"
							color="primary"
							style="padding-top: 32px !important;"
							class="mb-0 pr-2 grv-input"
							v-model="form.parameters[parameters_names.harmonize]">
						</v-checkbox>
					</v-flex>
					<v-flex v-if="form.parameters.hasOwnProperty(parameters_names.do_r128)" shrink>
						<v-checkbox
							hide-details
							:name="parameters_names.do_r128"
							:label="parameters[parameters_names.do_r128] | maestroParamLabel"
							color="primary"
							style="padding-top: 32px !important;"
							class="mb-0 pr-2 grv-input"
							v-model="form.parameters[parameters_names.do_r128]">
						</v-checkbox>
					</v-flex>
					<v-flex v-if="form.parameters.hasOwnProperty(parameters_names.dialogue_measurement)" shrink>
						<v-checkbox
							hide-details
							:name="parameters_names.dialogue_measurement"
							:label="parameters[parameters_names.dialogue_measurement] | maestroParamLabel"
							color="primary"
							style="padding-top: 32px !important;"
							class="mb-0 pr-2 grv-input"
							v-model="form.parameters[parameters_names.dialogue_measurement]">
						</v-checkbox>
					</v-flex>
					<v-flex v-if="form.parameters.hasOwnProperty(parameters_names.r128_measurement)" shrink>
						<v-checkbox
							hide-details
							:name="parameters_names.r128_measurement"
							:label="parameters[parameters_names.r128_measurement] | maestroParamLabel"
							color="primary"
							style="padding-top: 32px !important;"
							class="mb-0 pr-2 grv-input"
							v-model="form.parameters[parameters_names.r128_measurement]">
						</v-checkbox>
					</v-flex>
				</v-layout>

				<v-layout
					row wrap
					v-if="form.parameters.hasOwnProperty(parameters_names.audio_tracks)">
					<table id="audio-table" v-if="audio_tracks.length">
						<colgroup>
							<col style="width: 40px">
							<col>
							<col style="width: 200px">
						</colgroup>
						<thead>
							<tr>
								<td class="text-center">
									<v-btn
										flat icon
										color="warning"
										class="ma-0"
										:disabled="hasNoAudioSelected()"
										@click="emptyTracks('all')">
										<v-icon>close</v-icon>
									</v-btn>
								</td>
								<td>
									<span class="subheading">
										{{ parameters[parameters_names.audio_tracks] | maestroParamLabel }}
									</span>
								</td>
								<td class="px-2">
									<v-btn
										small
										block
										color="green accent-3 color--text"
										:disabled="!audio_tracks[0].path"
										:loading="probing"
										@click="validateTracks()">
										Validation
									</v-btn>
								</td>
							</tr>
						</thead>
						<tbody>
							<template v-for="(track, i) in audio_tracks">
								<tr v-if="current_segments.length > 1 && segmentStartLabel(i)"
									:key="'segment_' + i"
									class="mix-separator">
									<td class="text-center">
										<v-btn
											flat icon
											color="warning"
											class="ma-0"
											:disabled="hasMixNoAudioSelected(i)"
											@click="emptyMixTracks(i)">
											<v-icon>close</v-icon>
										</v-btn>
									</td>
									<td colspan="2">
										Mix {{ segmentStartLabel(i) }}
									</td>
								</tr>
								<tr :key="'track_' + i">
									<td class="text-center">
										<v-btn
											flat icon
											color="warning"
											class="ma-0"
											:disabled="!track.path"
											@click="emptyTracks(i)">
											<v-icon>close</v-icon>
										</v-btn>
									</td>
									<td>
										<v-input
											readonly
											solo
											hide-details
											:ref="parameters_names.audio_tracks"
											v-model="track.path"
											:loading="track.probe === '__in_progress__'"
											:name="parameters_names.audio_tracks"
											class="file-input grv-input grv-input-dense"
											:rules="getValidationRules(parameters_names.audio_tracks, i)">
											<template v-slot:prepend>
												<span v-if="audioconfig_mapping.hasOwnProperty(form.parameters[parameters_names.audio_config])">
													{{ audioconfig_mapping[form.parameters[parameters_names.audio_config]][i] }}
												</span>
											</template>
											<template v-slot:append>
												<v-btn
													flat icon small
													class="ma-0 ml-1"
													@click="showFileExplorer(parameters[parameters_names.audio_tracks], i)">
													<v-icon>folder_open</v-icon>
												</v-btn>
											</template>
											<span></span>
											<v-hover>
												<span slot-scope="{ hover }">
													<span v-if="hover" class="caption background--text text--lighten-5">
														{{ track.path }}
													</span>
													<span v-else>
														{{ track.path | fileBasename }}
													</span>
												</span>
											</v-hover>
										</v-input>
									</td>
									<td class="pa-1 text-center" style="line-height: 1.2">
										<div v-if="getDuplicateIndexFor(i) !== -1"
											class="error--text font-weight-bold">
											Doublon avec piste {{ getDuplicateIndexFor(i) + 1 }}
										</div>
										<div v-else-if="track.probe === '__in_progress__'">
											<v-progress-circular indeterminate color="primary" :width="2">
											</v-progress-circular>
										</div>
										<div v-else-if="track.valid === true"
											class="green--text text--accent-3">
											<span v-safe-html="track.probe"></span>
										</div>
										<div v-else-if="track.valid === false"
											class="error--text font-weight-bold">
											<span v-safe-html="track.probe"></span>
										</div>
										<div v-else class="warning--text subheading">- - -</div>
									</td>
								</tr>
							</template>
						</tbody>
					</table>
				</v-layout>

			</v-container>

		</v-form>

		<Explorer
			v-if="explorer.show"
			:assetType="explorer.asset_type"
			:multiselect="false"
			:default_folder="explorer.default_value"
			:return_dir_filelist="explorer.return_dir_filelist"
			toolbarTitle="Selectionnez des assets présents sur le filesystem"
			@close="onExplorerClose()"
			@selectedAssets="onSelectedAssets($event)">
		</Explorer>

		<v-dialog
			v-model="check_path_loader.active"
			hide-overlay
			persistent
			max-width="fit-content">
			<v-card color="primary">
				<v-card-text class="text-center">
					<span class="color--text headline">
						Check Path
					</span>
					<br>
					<span class="color--text subheading">
						{{ check_path_loader.path }}
					</span>
					<v-progress-linear
						indeterminate
						color="color"
						class="mb-0" />
				</v-card-text>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
import Explorer from '@/components/modal_explorer.vue'
import Path from 'path'
export default {
	props: [ 'wf_data', 'form' ],
	components: { Explorer },
	data () {
		return {
			explorer: {
				show: false,
				asset_type: null,
				destination_key: null,
				default_value: null,
				return_dir_filelist: false
			},
			probing: false,
			probe_status: null,
			parameters: {},
			check_path_loader: {
				active: false,
				path: ''
			},
			audioconfig_mapping: {
				'1.0': ['M'],
				'2.0': ['LT', 'RT'],
				'2.0 (single file)': ['LTRT'],
				'5.0': ['L', 'R', 'C', 'LS', 'RS'],
				'5.1': ['L', 'R', 'C', 'LFE', 'LS', 'RS'],
				'7.1': ['L', 'R', 'C', 'LFE', 'LS', 'RS', 'LSR', 'RSR'],
				'9.1': ['L', 'R', 'C', 'LFE', 'LS', 'RS', 'LSR', 'RSR', 'LTS', 'RTS'],
				'2.0 + 5.1': ['LT', 'RT', 'L', 'R', 'C', 'LFE', 'LS', 'RS'],
				'5.1 + 2.0': ['L', 'R', 'C', 'LFE', 'LS', 'RS', 'LT', 'RT'],
				'2.0 + 5.1 + 7.1': ['LT', 'RT', 'L', 'R', 'C', 'LFE', 'LS', 'RS', 'L', 'R', 'C', 'LFE', 'LS', 'RS', 'LSR', 'RSR']
			},
			// Découpage des configs combinées en sous-mix, pour piloter
			// l'auto-remplissage et l'affichage des séparateurs dans le tableau.
			// Les configs absentes de cette table sont traitées comme un
			// segment unique (cf. getSegmentsForConfig).
			audioconfig_segments: {
				'2.0 + 5.1': [
					{ label: '2.0', start: 0, length: 2 },
					{ label: '5.1', start: 2, length: 6 }
				],
				'5.1 + 2.0': [
					{ label: '5.1', start: 0, length: 6 },
					{ label: '2.0', start: 6, length: 2 }
				],
				'2.0 + 5.1 + 7.1': [
					{ label: '2.0', start: 0, length: 2 },
					{ label: '5.1', start: 2, length: 6 },
					{ label: '7.1', start: 8, length: 8 }
				]
			},
			// Suffixes alternatifs rencontrés dans les noms de fichiers
			// pour un même canal logique.
			channel_label_aliases: {
				LFE: ['LFE', 'SW'],
				LS: ['LS', 'LSS'],
				RS: ['RS', 'RSS']
			},
			output_folder_is_valid: false,
			audio_tracks: [],
			parameters_names: {
				audio_tracks: null,
				job_title: null,
				audio_config: null,
				varispeed_config: null,
				downmix_output_config: null,
				upmix_output_config: null,
				output_folder: null,
				measurement_only: null,
				harmonize: null,
				qt_profile: null,
				fps: null,
				do_r128: null,
				measurement_algorithm: null
			},
			default_output_folder: '/media/DATA/1305j552_calcul/maestro/audiotools/'
		}
	},
	watch: {
		audio_tracks: {
			deep: true,
			handler: function (val) {
				this.form.parameters[this.parameters_names.audio_tracks] = val.map(a => {
					return a.path
				})
			}
		}
	},
	computed: {
		// Segments (sous-mix) de la config audio_config actuellement sélectionnée.
		current_segments () {
			return this.getSegmentsForConfig(this.form.parameters[this.parameters_names.audio_config])
		}
	},
	methods: {
		// Retourne la découpe en segments (sous-mix) d'une config audio.
		// Si la config n'est pas référencée dans audioconfig_segments, elle
		// est considérée comme un segment unique couvrant tous ses canaux.
		getSegmentsForConfig (conf) {
			if (this.audioconfig_segments.hasOwnProperty(conf)) {
				return this.audioconfig_segments[conf]
			}
			if (this.audioconfig_mapping.hasOwnProperty(conf)) {
				return [ { label: conf, start: 0, length: this.audioconfig_mapping[conf].length } ]
			}
			return []
		},
		// Retourne le segment contenant l'index de piste donné pour une config.
		getSegmentForIndex (conf, index) {
			const segments = this.getSegmentsForConfig(conf)
			return segments.find(segment => index >= segment.start && index < segment.start + segment.length)
		},
		// Libellé du segment démarrant à l'index donné, pour afficher un
		// séparateur dans le tableau des pistes (null si non applicable).
		segmentStartLabel (index) {
			const segment = this.current_segments.find(s => s.start === index)
			return segment ? segment.label : null
		},
		init () {
			this.output_folder_is_valid = false
			this.wf_data.parameters.map(param => {
				this.parameters[param.name] = param
			})
			for (const paramName in this.form.parameters) {
				if (['Audio Tracks', 'audio_tracks'].indexOf(paramName) > -1) {
					this.parameters_names.audio_tracks = paramName
				} else if (['Job Title', 'job_title'].indexOf(paramName) > -1) {
					this.parameters_names.job_title = paramName
				} else if (['Audio Config', 'audio_config'].indexOf(paramName) > -1) {
					this.parameters_names.audio_config = paramName
				} else if (['Varispeed Config', 'varispeed_config'].indexOf(paramName) > -1) {
					this.parameters_names.varispeed_config = paramName
				} else if (['Downmix Output Config', 'downmix_output_config'].indexOf(paramName) > -1) {
					this.parameters_names.downmix_output_config = paramName
				} else if (['Upmix Output Config', 'upmix_output_config'].indexOf(paramName) > -1) {
					this.parameters_names.upmix_output_config = paramName
				} else if (['Output Folder', 'output_folder'].indexOf(paramName) > -1) {
					this.parameters_names.output_folder = paramName
				} else if (['Measurement Only', 'measurement_only'].indexOf(paramName) > -1) {
					this.parameters_names.measurement_only = paramName
				} else if (['Harmonize', 'harmonize'].indexOf(paramName) > -1) {
					this.parameters_names.harmonize = paramName
				} else if (['QT Profile', 'qt_profile'].indexOf(paramName) > -1) {
					this.parameters_names.qt_profile = paramName
				} else if (['Fps', 'fps'].indexOf(paramName) > -1) {
					this.parameters_names.fps = paramName
				} else if (['Dialogue Measurement', 'dialogue_measurement'].indexOf(paramName) > -1) {
					this.parameters_names.dialogue_measurement = paramName
				} else if (['R128 Measurement', 'r128_measurement'].indexOf(paramName) > -1) {
					this.parameters_names.r128_measurement = paramName
				} else if (['do_r128'].indexOf(paramName) > -1) {
					this.parameters_names.do_r128 = paramName
				} else if (['measurement_algorithm'].indexOf(paramName) > -1) {
					this.parameters_names.measurement_algorithm = paramName
				}

				if (['Output Folder', 'output_folder'].indexOf(paramName) > -1) {
					this.$set(this.form.parameters, paramName, this.default_output_folder)
					this.output_folder_is_valid = true
				} else if (['Audio Config', 'audio_config'].indexOf(paramName) > -1 && this.form.parameters[paramName]) {
					this.onAudioConfChange(this.form.parameters[paramName])
				} else if (['Audio Tracks', 'audio_tracks'].indexOf(paramName) > -1) {
					this.audio_tracks = []
					if (this.form.parameters[paramName]) {
						for (let i = 0; i < this.form.parameters[paramName].length; i++) {
							this.$set(this.audio_tracks, i,
								{
									path: this.form.parameters[paramName][i],
									valid: null,
									probing: false
								}
							)
						}
					}
				}
			}
			this.form.isValid = false
		},
		showFileExplorer (param, index) {
			if (param.name === this.parameters_names.output_folder) {
				this.explorer.asset_type = 'folder'
			} else if (param.name === this.parameters_names.audio_tracks) {
				this.explorer.asset_type = 'file'
				const segment = this.getSegmentForIndex(this.form.parameters[this.parameters_names.audio_config], index)
				if (segment && segment.start === index && segment.length > 1) {
					this.explorer.return_dir_filelist = true
				}
			} else {
				this.explorer.asset_type = null
			}
			this.explorer.default_value = null
			if (param.default) {
				this.explorer.default_value = this.$paths.maestroToUNC(param.default)
			}
			this.explorer.destination_key = param.name
			this.explorer.destination_index = index
			this.explorer.show = true
		},
		onExplorerClose () {
			this.explorer.show = false
			this.explorer.asset_type = null
			this.explorer.destination_key = null
			this.explorer.destination_index = null
			this.explorer.return_dir_filelist = false
		},
		onSelectedAssets (evt) {
			if (this.explorer.return_dir_filelist === false) {
				let maestroPath = this.$paths.UNCToMaestro(evt.path)
				if (evt.type === 'folder') {
					maestroPath = maestroPath + '/'
				}
				if (this.explorer.destination_key === this.parameters_names.output_folder) {
					this.$set(this.form.parameters, this.parameters_names.output_folder, maestroPath)
					this.output_folder_is_valid = true
				} else if (this.explorer.destination_key === this.parameters_names.audio_tracks) {
					this.$set(
						this.audio_tracks,
						this.explorer.destination_index,
						{ path: maestroPath, valid: null, probe: '' }
					)
				}
			} else {
				let maestroPath = this.$paths.UNCToMaestro(evt.selected.path)
				this.$set(
					this.audio_tracks,
					this.explorer.destination_index,
					{ path: maestroPath, valid: null, probe: '' }
				)
				this.autofillSegment(evt.selected.path, evt.filelist, this.explorer.destination_index)
			}
			this.form.isValid = false
			this.onExplorerClose()
			let allAudioTracksFilled = true
			for (const track of this.audio_tracks) {
				if (!track.path) {
					allAudioTracksFilled = false
					break
				}
			}
			if (allAudioTracksFilled) this.validateTracks()
		},
		// Auto-remplissage des autres pistes du mix (segment) auquel appartient
		// clickedIndex, à partir des fichiers voisins (filelist) du fichier
		// sélectionné (selectedPath). N'agit que si aucune autre piste du
		// segment n'est déjà renseignée.
		autofillSegment (selectedPath, filelist, clickedIndex) {
			const conf = this.form.parameters[this.parameters_names.audio_config]
			const segment = this.getSegmentForIndex(conf, clickedIndex)
			if (!segment || segment.length <= 1) return

			// Ne pas auto-remplir si une autre piste du segment est déjà renseignée
			for (let i = segment.start; i < segment.start + segment.length; i++) {
				if (i !== clickedIndex && this.audio_tracks[i] && this.audio_tracks[i].path) {
					return
				}
			}

			let _arr = selectedPath.split(/[._]/)
			let baseEndIndex = selectedPath.lastIndexOf(_arr[_arr.length - 2])
			let base = selectedPath.substring(0, baseEndIndex)

			let selectedSuffixIndex = _arr.length - 2
			let selectedSuffix = _arr[selectedSuffixIndex]
			if (selectedSuffix) selectedSuffix = selectedSuffix.toUpperCase()

			let selectedExt = _arr[_arr.length - 1]
			if (selectedExt) selectedExt = selectedExt.toUpperCase()

			const segmentLabels = this.audioconfig_mapping[conf].slice(segment.start, segment.start + segment.length)
			const clickedLocalIndex = clickedIndex - segment.start
			const selectedIsNumeric = Number.isInteger(parseInt(selectedSuffix))

			filelist.map(file => {
				if (file.indexOf(base) !== 0) return

				let fileArr = file.split(/[._]/)
				let fileExt = fileArr[fileArr.length - 1]
				if (fileExt) fileExt = fileExt.toUpperCase()
				if (fileExt !== selectedExt) return

				let fileSuffix = fileArr[selectedSuffixIndex]
				if (fileSuffix) fileSuffix = fileSuffix.toUpperCase()

				if (selectedIsNumeric) {
					if (!Number.isInteger(parseInt(fileSuffix))) return
					let selectedInt = parseInt(selectedSuffix)
					let fileInt = parseInt(fileSuffix)
					let localIndex = clickedLocalIndex + (fileInt - selectedInt)
					if (localIndex < 0 || localIndex >= segment.length || localIndex === clickedLocalIndex) return
					let maestroPath = this.$paths.UNCToMaestro(file)
					this.$set(this.audio_tracks, segment.start + localIndex,
						{ path: maestroPath, valid: null, probe: '' }
					)
					return
				}

				segmentLabels.forEach((label, localIndex) => {
					if (localIndex === clickedLocalIndex) return
					const aliases = this.channel_label_aliases[label] || [label]
					if (aliases.indexOf(fileSuffix) === -1) return
					let maestroPath = this.$paths.UNCToMaestro(file)
					this.$set(this.audio_tracks, segment.start + localIndex,
						{ path: maestroPath, valid: null, probe: '' }
					)
				})
			})
		},
		hasNoAudioSelected () {
			return !this.audio_tracks.some(track => track && track.path)
		},
		hasMixNoAudioSelected (index) {
			const segment = this.current_segments.find(s => s.start === index)
			if (segment) {
				for (let i = index; i < index + segment.length; i++) {
					if (this.audio_tracks[i] && this.audio_tracks[i].path) return false
				}
			}
			return true
		},
		outputFolderPathCleaner (paramName) {
			let path = this.form.parameters[paramName]
			path = path.trim()

			// Clean double quotes from windows paste
			if (path[0] === '"') path = path.slice(1)
			if (path[path.length - 1] === '"') path = path.slice(0, path.length - 1)
			// Clean windows backslashes
			let newPath = path.replace(/\\/g, '/')
			if (newPath.toLowerCase().indexOf('/media/data') > -1) {
				newPath = this.$paths.maestroToUNC(newPath)
			}
			if (!newPath) {
				this.form.isValid = false
				return
			}
			let maestroPath = this.$paths.UNCToMaestro(newPath)
			if (maestroPath[maestroPath.length - 1] !== '/') maestroPath += '/'
			this.form.parameters[this.parameters_names.output_folder] = maestroPath
			this.$refs[paramName].badInput = false
			this.$refs[paramName].errorBucket = []
			this.output_folder_is_valid = true
			this.$set(this.form.parameters, paramName, maestroPath)
			this.check_path_loader.active = true
			this.check_path_loader.path = newPath
			this.$ApiNexus.exist(maestroPath)
				.then(result => {
					if (!result.data) throw new Error('le chemin ne semble pas exister')
				})
				.catch(error => {
					this.$refs[paramName].badInput = true
					this.$refs[paramName].errorBucket.push(
						error.message
					)
					this.output_folder_is_valid = false
					this.form.isValid = false
				})
				.finally(() => {
					this.check_path_loader.active = false
					this.check_path_loader.path = ''
				})
		},
		audioConfToNbChannels (conf) {
			let nbCh = 0
			if (this.audioconfig_mapping.hasOwnProperty(conf)) {
				nbCh = this.audioconfig_mapping[conf].length
			}
			return nbCh
		},
		emptyTracks (index) {
			if (index === 'all') {
				for (let i = 0; i < this.audio_tracks.length; i++) {
					this.$set(
						this.audio_tracks,
						i,
						{ path: '', valid: null, probe: '' }
					)
				}
			} else {
				this.$set(
					this.audio_tracks,
					index,
					{ path: '', valid: null, probe: '' }
				)
			}
			this.$forceUpdate()
			this.form.isValid = false
		},
		emptyMixTracks (index) {
			const segment = this.current_segments.find(s => s.start === index)
			if (segment) {
				for (let i = index; i < index + segment.length; i++) {
					this.emptyTracks(i)
				}
			}
		},
		onAudioConfChange (conf) {
			let nbCh = this.audioConfToNbChannels(conf)
			this.audio_tracks = this.audio_tracks.splice(0, nbCh)
			for (let i = 0; i < nbCh; i++) {
				if (!this.audio_tracks[i]) {
					this.$set(this.audio_tracks, i, { path: '', valid: null, probe: '' })
					this.form.isValid = false
				}
			}
		},
		getFileBasename (filepath) {
			try {
				let basename = Path.basename(filepath)
				if (basename) return './' + Path.basename(filepath)
				return ''
			} catch (error) {
				return ''
			}
		},
		probeFile (filepath) {
			return new Promise((resolve, reject) => {
				this.$ApiNexus.ffprobe(filepath)
					.then(result => {
						resolve(result.data.detail)
					})
					.catch(error => {
						console.error('probeFile error', error.response.data)
						reject(error)
					})
			})
		},
		async validateTracks () {
			this.probing = true
			this.probe_status = null
			let prevDuration = null
			for (let i = 0; i < this.audio_tracks.length; i++) {
				const track = this.audio_tracks[i]
				if (track.path) {
					try {
						let trackValidity = true
						let trackInValidityReason = []
						let uncPath = this.$paths.maestroToUNC(track.path)
						track.probe = '__in_progress__'
						let probe = await this.probeFile(uncPath)
						if (probe.video) {
							track.valid = false
							this.form.isValid = false
							track.probe = 'Stream not audio only'
						} else if (probe.audio.length === 0) {
							track.valid = false
							this.form.isValid = false
							track.probe = 'No audio stream found'
						} else {
							for (const stream of probe.audio) {
								let nb_ch = stream.channels
								if (this.form.parameters[this.parameters_names.audio_config] === '2.0 (single file)') {
									if (nb_ch !== 2) {
										trackValidity = false
										trackInValidityReason.push('Nb channel != 2')
										this.form.isValid = false
									}
								} else {
									if (nb_ch !== 1) {
										trackValidity = false
										trackInValidityReason.push('Nb channel > 1')
										this.form.isValid = false
									}
								}
								let bitdepth = stream.bits_per_sample
								let samplerate = stream.sample_rate
								let duration = stream.duration
								if (prevDuration && duration !== prevDuration) {
									trackValidity = false
									trackInValidityReason.push('Durée différente')
									this.form.isValid = false
								}
								prevDuration = duration
								let probeString = [
									`${nb_ch}ch`,
									`${bitdepth}bits`,
									`${samplerate}hz`,
									this.$time.secondsToTcMs(duration),
									`<br>${trackInValidityReason.join('<br>')}`
								]
								probeString = probeString.join(' ')
								track.valid = trackValidity
								track.probe = probeString
							}
						}
					} catch (error) {
						track.valid = false
						this.form.isValid = false
						track.probe = error.response.data
					}
					this.$forceUpdate()
				} else if (!track.path) {
					track.valid = false
					track.probe = 'Requis'
				}
			}
			this.validate()
			this.probing = false
		},
		checkRequired (value) {
			if (value === '') return 'Requis'
			if (value === null) return 'Requis'
			if (value === undefined) return 'Requis'
			return true
		},
		checkAudioTrackRow (value, index) {
			const duplicateIndex = this.getDuplicateIndexFor(index)
			if (duplicateIndex !== -1) {
				return `Fichier en doublon avec la piste ${duplicateIndex + 1}`
			}
			const track = this.audio_tracks[index]
			if (track && track.valid === false && track.probe !== '__in_progress__') {
				return track.probe || 'Piste à valider'
			}
			return true
		},
		// Retourne l'index d'une autre piste partageant le même fichier
		// (chemin strictement identique), ou -1 si aucun doublon.
		getDuplicateIndexFor (index) {
			const track = this.audio_tracks[index]
			if (!track || !track.path) return -1
			for (let i = 0; i < this.audio_tracks.length; i++) {
				if (i !== index && this.audio_tracks[i].path === track.path) return i
			}
			return -1
		},
		checkOutputFolder () {
			if (!this.output_folder_is_valid) {
				return 'le repertoire de sortie ne semble pas valide'
			}
			return true
		},
		getValidationRules (paramName, index) {
			if (['Audio Tracks', 'audio_tracks'].indexOf(paramName) > -1) {
				return [ this.checkRequired, (value) => this.checkAudioTrackRow(value, index) ]
			} else if (['Job Title', 'job_title'].indexOf(paramName) > -1) {
				return [ this.checkRequired ]
			} else if (['Audio Config', 'audio_config'].indexOf(paramName) > -1) {
				return [ this.checkRequired ]
			} else if (['Varispeed Config', 'varispeed_config'].indexOf(paramName) > -1) {
				return [ this.checkRequired ]
			} else if (['Downmix Output Config', 'downmix_output_config'].indexOf(paramName) > -1) {
				return [ this.checkRequired ]
			} else if (['Upmix Output Config', 'upmix_output_config'].indexOf(paramName) > -1) {
				return [ this.checkRequired ]
			} else if (['Output Folder', 'output_folder'].indexOf(paramName) > -1) {
				return [ this.checkRequired, this.checkOutputFolder ]
			} else if (['QT Profile', 'qt_profile'].indexOf(paramName) > -1) {
				return [ this.checkRequired ]
			} else if (['Fps', 'fps'].indexOf(paramName) > -1) {
				return [ this.checkRequired ]
			} else if (['measurement_algorithm'].indexOf(paramName) > -1) {
				return [ this.checkRequired ]
			}
		},
		getOutputForm () {
			let form = {
				isValid: true,
				parameters: {},
				jobdescriptorID: this.form.jobdescriptorID,
				jobDescriptorVersion: this.form.jobDescriptorVersion
			}

			// Set & Check output folder
			if (this.form.parameters.hasOwnProperty(this.parameters_names.output_folder)) {
				form.parameters[this.parameters_names.output_folder] = this.form.parameters[this.parameters_names.output_folder]
				if (!this.form.parameters[this.parameters_names.output_folder]) form.isValid = false
				if (this.$refs[this.parameters_names.output_folder]) {
					if (this.$refs[this.parameters_names.output_folder].badInput) form.isValid = false
				}
			}

			// Set Measurement Only
			if (this.form.parameters.hasOwnProperty(this.parameters_names.measurement_only)) {
				form.parameters[this.parameters_names.measurement_only] = this.form.parameters[this.parameters_names.measurement_only]
			}

			// Set R128 Measurement
			if (this.form.parameters.hasOwnProperty(this.parameters_names.r128_measurement)) {
				form.parameters[this.parameters_names.r128_measurement] = this.form.parameters[this.parameters_names.r128_measurement]
			}

			// Set Dialog Measurement
			if (this.form.parameters.hasOwnProperty(this.parameters_names.dialogue_measurement)) {
				form.parameters[this.parameters_names.dialogue_measurement] = this.form.parameters[this.parameters_names.dialogue_measurement]
			}

			// Set Harmonize
			if (this.form.parameters.hasOwnProperty(this.parameters_names.harmonize)) {
				form.parameters[this.parameters_names.harmonize] = this.form.parameters[this.parameters_names.harmonize]
			}

			// Set Job Title
			if (this.form.parameters.hasOwnProperty(this.parameters_names.job_title)) {
				form.parameters[this.parameters_names.job_title] = this.form.parameters[this.parameters_names.job_title]
			}

			// Set do_r128
			if (this.form.parameters.hasOwnProperty(this.parameters_names.do_r128)) {
				form.parameters[this.parameters_names.do_r128] = this.form.parameters[this.parameters_names.do_r128]
			}

			// Set measurement_algorithm
			if (this.form.parameters.hasOwnProperty(this.parameters_names.measurement_algorithm)) {
				form.parameters[this.parameters_names.measurement_algorithm] = this.form.parameters[this.parameters_names.measurement_algorithm]
			}

			// Set & Check audio config
			if (this.form.parameters.hasOwnProperty(this.parameters_names.audio_config)) {
				form.parameters[this.parameters_names.audio_config] = this.form.parameters[this.parameters_names.audio_config]
				if (this.parameters[this.parameters_names.audio_config].choices.indexOf(form.parameters[this.parameters_names.audio_config]) === -1) {
					form.isValid = false
				}
			}

			// Set & Check Downmix Output Config
			if (this.form.parameters.hasOwnProperty(this.parameters_names.downmix_output_config)) {
				form.parameters[this.parameters_names.downmix_output_config] = this.form.parameters[this.parameters_names.downmix_output_config]
				if (this.parameters[this.parameters_names.downmix_output_config].choices.indexOf(form.parameters[this.parameters_names.downmix_output_config]) === -1) {
					form.isValid = false
				}
			}

			// Set & Check Upmix Output Config
			if (this.form.parameters.hasOwnProperty(this.parameters_names.upmix_output_config)) {
				form.parameters[this.parameters_names.upmix_output_config] = this.form.parameters[this.parameters_names.upmix_output_config]
				if (this.parameters[this.parameters_names.upmix_output_config].choices.indexOf(form.parameters[this.parameters_names.upmix_output_config]) === -1) {
					form.isValid = false
				}
			}

			// Set & Check Varispeed Config
			if (this.form.parameters.hasOwnProperty(this.parameters_names.varispeed_config)) {
				form.parameters[this.parameters_names.varispeed_config] = this.form.parameters[this.parameters_names.varispeed_config]
				if (this.parameters[this.parameters_names.varispeed_config].choices.indexOf(form.parameters[this.parameters_names.varispeed_config]) === -1) {
					form.isValid = false
				}
			}

			// Set & Check QT Profile
			if (this.form.parameters.hasOwnProperty(this.parameters_names.qt_profile)) {
				form.parameters[this.parameters_names.qt_profile] = this.form.parameters[this.parameters_names.qt_profile]
				if (this.parameters[this.parameters_names.qt_profile].choices.indexOf(form.parameters[this.parameters_names.qt_profile]) === -1) {
					form.isValid = false
				}
			}

			// Set & Check fpss
			if (this.form.parameters.hasOwnProperty(this.parameters_names.fps)) {
				form.parameters[this.parameters_names.fps] = this.form.parameters[this.parameters_names.fps]
				if (this.parameters[this.parameters_names.fps].choices.indexOf(form.parameters[this.parameters_names.fps]) === -1) {
					form.isValid = false
				}
			}

			// Set & Check audio tracks
			if (this.form.parameters.hasOwnProperty(this.parameters_names.audio_tracks)) {
				let tracks = []
				this.form.parameters[this.parameters_names.audio_tracks].map(track => {
					if (track.path) {
						tracks.push(track.path)
						if (!track.valid) form.isValid = false
					} else {
						form.isValid = false
					}
				})
				form.parameters[this.parameters_names.audio_tracks] = tracks.join(', ')
			}

			return form
		},
		validate () {
			let isValid = this.$refs.unitary_form.validate()
			this.form.isValid = isValid
			return isValid
		},
		resetValidation () {
			return this.$refs.unitary_form.resetValidation()
		}
	},
	mounted () {
		this.init()
		this.$emit('modal-width', '1200px')
	}
}
</script>

<style scoped lang="stylus">
.file-input
	>>>.v-input__prepend-outer
		width: 30px
		font-size: 14px
		margin: 0 4px 0 0
		color: var(--v-background-lighten5)
		align-self: center
		justify-content: flex-end
	>>>.v-text-field__slot
		.v-text-field__prefix
			font-size: 12px
			font-weight: 400
			margin: 2px 2px 0 6px
			white-space: nowrap
		input
			font-size: 12px !important
			color: var(--v-background-lighten5)

#audio-table
	width: 100%
	margin-top: 16px
	thead
		td
			color: var(--v-background-lighten5)
	tbody
		tr
			border-top: 1px solid var(--v-background-lighten1)
			td
				vertical-align: middle
				padding: 4px 0
				.grv-input
					>>>.v-input__control
						margin-bottom: 0 !important
		tr.mix-separator
			border-top: none
			td
				padding: 10px 0 2px 2px
				font-size: 11px
				font-weight: 700
				letter-spacing: 1px
				text-transform: uppercase
				color: var(--v-primary-lighten2)
</style>



// WEBPACK FOOTER //
// src/pages/maestro/launcher/forms/launcher_form_audiotools_audiofiles.vue